import { PRODUCT_LECTURA } from 'root/lib/constants';
import {
  PLACEMENT_TOOL,
  TRO_BENCHMARK,
  INTERSTITIAL_IDS,
  PLACEMENT_TOOL_ES,
  LOCAL_STORAGE_KEYS,
  APT_TYPES,
} from 'a/placementTool/data/constants';
import MEASURE_IDS from '../../data/measureIds';

export const getStudentTOY = (state) => {
  const localTOY = localStorage.getItem(LOCAL_STORAGE_KEYS.LOCAL_APT_TYPE);
  if (localTOY) {
    return localTOY;
  }
  return state.persistStateReducer.toy;
};

export const getCurrentScreen = state => state.placementTool.currentScreen;

export const getCurrentMeasure = state => state.placementTool.currentMeasure;

export const getCurrentInterstitial = state => state.placementTool.currentInterstitial;

export const getResults = state => state.placementTool.results;

export const getPlacements = state => state.placementTool.placements;

export const getDefaultPlacement = state => state.placementTool.default;

export const getRemainingMeasures = state => state.placementTool.measuresRemaining;

export const getMeasuresCompleted = state => state.placementTool.measuresCompleted;

export const getHasLoadedIntoOutro = state => state.placementTool.hasLoadedIntoOutro;

// index of next mtg passage to show is number of completed mtg passages
export const getPlacementMindTheGapCurriculum = (state) => {
  const { id, curriculum } = getCurrentMeasure(state);
  return id === MEASURE_IDS.MIND_THE_GAP ? curriculum : undefined;
};

export const getCurrentPlacementProgress = state => ({
  rwrId: state.placementTool.roundSessionIds.rwrId,
  mtgIdStory1: state.placementTool.roundSessionIds.mtgIdStory1,
  mtgIdStory2: state.placementTool.roundSessionIds.mtgIdStory2,
  benchmarkId: state.placementTool.roundSessionIds.benchmarkId,
  currentMeasure: state.placementTool.currentMeasure,
  measuresCompleted: state.placementTool.measuresCompleted,
  measureInProgress: state.placementTool.measureInProgress,
  measuresRemaining: state.placementTool.measuresRemaining,
  results: state.placementTool.results,
  placements: state.placementTool.placements,
  metrics: state.placementTool.metrics,
});

export const getMetrics = state => state.placementTool.metrics;

export const getStudentId = state => state.persistStateReducer.studentId;

export const getBenchmarkId = state => state.placementTool.benchmarkId;

export const getRoundSessionIds = state => state.placementTool.roundSessionIds;

export const getRoundSessionId = (state, measureId) => getRoundSessionIds(state)[measureId];

export const getTroData = state => state.placementTool.troData;

export const getIsTroRequestResolved = state => state.placementTool.isTroRequestResolved;

export const getIsTroRequestFailure = state => state.placementTool.isTroRequestFailure;

export const getIsValidTroResult = state => state.placementTool.isValidTroResult;

export const getIsBenchmarkModeOn = state => state.placementTool.isBenchmarkModeOn;

// benchmarkEOY value comes from tro_benchmark gamestate bucket
// Values can be APT (Grade K), TRO-APT (Grade 1+), or null
// Only serve if valid value and TOY is EOY
export const getBenchmarkEOYPath = state => (
  state.persistStateReducer.toy === APT_TYPES.EOY ? state.placementTool.benchmarkEOY : null
);

export const getHasCompletedRWR = state => state.placementTool.hasCompletedRWR;

export const getTeacherResetInfo = state => state.placementTool.teacherResetInfo;

export const getCurrentAssessment = (state) => {
  const { product } = state.appSessionReducer;
  if (getIsBenchmarkModeOn(state) || getBenchmarkEOYPath(state)) {
    return TRO_BENCHMARK;
  }
  return product === PRODUCT_LECTURA ? PLACEMENT_TOOL_ES : PLACEMENT_TOOL;
};

export const getIsStartOfAssessment = (state) => {
  const currentInterstitialId = getCurrentInterstitial(state);
  const isBenchmarkModeOn = getIsBenchmarkModeOn(state);

  return currentInterstitialId === INTERSTITIAL_IDS.INTRO
    || (currentInterstitialId === INTERSTITIAL_IDS.WELCOME_BACK && isBenchmarkModeOn);
};
